module.exports = __webpack_public_path__ + "static/media/translate_portuguese.54e9dcea.svg";